angular.module('eatself')
.directive('relativeWidth', function($timeout) {
  return {
    scope: {
      relativeWidth: '=',
    },
    link: function($scope, $element, $attrs) {
      var update = function() {
        $timeout(function() {
          $scope.relativeWidth = $element.width()/$(window).width()
        })
      }

      update();
      angular.element(window).resize(update);
      $element.resize(update);
    }
  };
})